export const cartItemIds = (cartItems) => {
  return cartItems ? cartItems.map((item) => item.product_id) : [];
};
